"use client"

import type { WidgetRegistrationContentProps } from "@/types/types"
import { useWidgetRegistration } from "../hooks/useWidgetRegistration"
import { WidgetRegistrationItem } from "./WidgetRegistrationItem"

export const WidgetRegistrationContent = ({
  id,
  items = [],
  className = "",
  title,
  isCMS = false,
}: WidgetRegistrationContentProps) => {
  const { validItems, hasValidItems } = useWidgetRegistration({
    items,
    componentId: id,
  })

  if (!hasValidItems) {
    return null
  }

  return (
    <div className={`w-full ${className}`} id={id}>
      {title && (
        <div className="w-full px-4 pt-8 pb-7 sm:px-4 sm:pt-0 sm:pb-[1.75rem]">
          <h2 className="text-lg sm:text-2xl font-extrabold leading-[1.74375rem] sm:leading-[2.325rem] text-[#333333] text-center uppercase">
            {title}
          </h2>
        </div>
      )}

      <div className="flex flex-col gap-[0.375rem] px-4 pb-4 sm:grid sm:grid-cols-2 sm:gap-5 sm:pb-8 sm:px-2">
        {validItems.map((item, index) => (
          <div key={index} className="w-full bg-white rounded-lg shadow-md overflow-hidden">
            <WidgetRegistrationItem item={item} isCMS={isCMS} />
          </div>
        ))}
      </div>
    </div>
  )
}
